import _ from '../common/utility';
import lazyLoadImages from '../common/lazy-load';
import tracking from '../common/tracking';
import partnerTwoCol from './modules/partner-two-col';
import indexFilter from './modules/index-filter';
import digitalHub from './modules/digital-hub';
import facultyBioVideo from './modules/faculty-bio-video';

$(() => {
    _.initJQueryPlugin();
	lazyLoadImages();
	tracking();
	partnerTwoCol();
	indexFilter();
	digitalHub();
	facultyBioVideo();
});